import React from 'react'
import { Modal } from 'react-bootstrap'
import Button from 'components/components/Button'
import { T } from 'components/components/i18n'
import styles from './styles.less'

const DEFAULT_MESSAGE = 'Selected quantity is 0. Please enter a valid quantity.'
const DEFAULT_TITLE = 'Notice'

const ZeroQuantityModal = ({
  show,
  onHide,
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE
}) => {
  if (!message) return null
  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName={styles.centeredDialog}
    >
      {!!title && (
        <Modal.Header closeButton>
          <Modal.Title><T id={title} /></Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body><T id={message} /></Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} label="Close" />
      </Modal.Footer>
    </Modal>
  )
}

export default ZeroQuantityModal
